import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
    interface Window {
        gtag: (
            command: string,
            targetId: string,
            config?: Record<string, any>
        ) => void
    }
}

export const usePageTracking = () => {
    const location = useLocation()

    useEffect(() => {
        if (typeof window.gtag === 'function') {
            window.gtag('config', 'G-6S03FB2H53', {
                page_path: location.pathname + location.search,
                page_title: document.title || location.pathname,
            })
        }
    }, [location])
}
